export default __webpack_public_path__ + "static/media/mua-sam-1.4b758155.jpg";